<template>
    <div ref="discuss" class="discuss-wrap">
        <van-list
            v-model="isloading"
            :offset="50"
            direction="down"
            :finished="isfinished"
            :immediate-check="false"
            @load="onListLoad"
        >
            <div class="panel"></div>
            <div :class="['discuss-screen', {'discuss-screen-unfold':isUnfold}]">
                <div class="screen-panel">
                    <div :class="['screen-item', {'screen-item-act':nScreenIndex == 0}]" @click="toScreen(0)">
                        <p>全部<span>({{ objNum.total_num > 999 ? '999+' : objNum.total_num }})</span></p>
                    </div>
                    <div :class="['screen-item', {'screen-item-act':nScreenIndex == 1}]" @click="toScreen(1)">
                        <img src="@/assets/images/project/v3/pic.png" alt="">
                        <p>有图/视频<span>({{ objNum.pic_num > 999 ? '999+' : objNum.pic_num }})</span></p>
                    </div>
                    <div :class="['screen-item', {'screen-item-act':nScreenIndex == 2}]" @click="toScreen(2)">
                        <p>追加<span>({{ objNum.zhui_num > 999 ? '999+' : objNum.zhui_num }})</span></p>
                    </div>
                    <div class="sort-item" @click="toSort">
                        <p>{{ sortType == 'id' ? '默认' : '时间' }}</p>
                        <img v-if="sortType == 'id'" src="@/assets/images/project/def-sort.png" alt="">
                        <img v-if="sortType == 'time'" src="@/assets/images/project/time-sort.png" alt="">
                    </div>
                </div>
                <div class="screen-tag-panel">
                    <template v-for="(item,index) in screenTag">
                        <div v-if="index < 12" :class="['tag-item', {'tag-item-act':nTagIndex == index}]"
                             @click="toTag(index)">
                            {{ item.title }}{{ item.num }}
                        </div>
                    </template>
                </div>
                <div :class="['screen-btn', {'screen-unfold':isUnfold}]">
                    <img src="@/assets/images/project/v3/down_icon2.png" alt="" @click="toScreenUnfold">
                </div>
            </div>
            <template v-for="(item,index) in arrDiscuss">
                <div v-show="item.isShow" :ref="`discuss_${item.id}`" class="discuss-dot"></div>
                <div v-show="item.isShow" class="discuss-panel">
                    <div v-if="item.project_id" class="pro-box" @click="touchCase(item.project_id)">
                        <div class="title">{{ item.city }}{{ item.project_name }}项目案例</div>
                        <div class="btn"></div>
                    </div>
                    <div v-if="item.userInfo" class="user-box">
                        <div class="vague-img">
                            <img :src="item.userInfo.img" alt="">
                        </div>
                        <!-- <img v-if="item.userInfo.imgtype" src="@/assets/images/project/v3/daf_head1.png" alt="">-->
                        <!-- <img v-else src="@/assets/images/project/v3/daf_head2.png" alt="">-->
                        <div class="info">
                            <div class="name">
                                {{ item.userInfo.name ? handleUserName(item.userInfo.name) : '***' }}
                                <p v-if="item.userInfo.isOrigin">本案例用户评价</p>
                            </div>
                            <p class="time">{{ item.userInfo.time }}</p>
                        </div>
                        <div v-if="isZxy" class="share-box" @click="toDiscussShare(item)">
                            <img src="@/assets/images/project/share-icon.png" alt="">
                            分享
                        </div>
                    </div>
                    <!-- 施工 -->
                    <template v-if="item.isUnfoldDiscuss">
                        <div v-if="item.sgInfo" class="discuss-box">
                            <div class="title">
                                <p>系统施工评价</p>
                                <vantRate v-model="item.sgInfo.score_num" allow-half color="#ffd21e" void-icon="star"
                                          :size="16"
                                          void-color="#eee"></vantRate>
                                <p class="score">{{ item.sgInfo.score }}分</p>
                            </div>
                            <div class="content">
                                {{ item.sgInfo.content }}
                            </div>
                            <div v-if="item.sgInfo.voice" class="audio-box" @click="playAudio(index,'sgInfo')">
                                <div class="icon">
                                    <img :class="['audio-icon', {'audio-icon-act':item.sgInfo.isOpenVoice}]"
                                         src="@/assets/images/project/v3/audio_icon.png"
                                         alt="">
                                </div>
                                <div class="time">
                                    {{ item.sgInfo.voice_time }}s
                                </div>
                                <div class="red-dit"></div>
                                <audio :ref="`sgInfo_${index}`" :src="item.sgInfo.voice"
                                       @ended="onAudioEnd(index,'sgInfo')"></audio>
                            </div>
                            <div v-if="item.sgInfo.pic && item.sgInfo.pic.length > 0" class="img-box">
                                <template v-for="(pic,pic_i) in item.sgInfo.pic">
                                    <div :class="['img-item',{'video_mask':pic.type != 'image'}]">
                                        <img alt="" @click="toPreview(item.sgInfo.pic,pic_i)"
                                             :src="pic.type == 'image' ? pic.pic : pic.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                    </div>
                                </template>
                            </div>
                            <div v-if="item.isShowUnfold" class="split"></div>
                        </div>
                    </template>
                    <!-- 竣工 -->
                    <template v-if="item.zpInfo? item.isUnfoldDiscuss :true">
                        <div v-if=" item.jgInfo" class="discuss-box">
                            <div class="title">
                                <p>竣工交付评价</p>
                                <vantRate v-model="item.jgInfo.score_num" allow-half color="#ffd21e" void-icon="star"
                                          :size="16"
                                          void-color="#eee"></vantRate>
                                <p class="score">{{ item.jgInfo.score }}分</p>
                            </div>
                            <div class="content">
                                {{ item.jgInfo.content }}
                            </div>
                            <div v-if="item.jgInfo.voice" class="audio-box" @click="playAudio(index,'jgInfo')">
                                <div class="icon">
                                    <img :class="['audio-icon', {'audio-icon-act':item.jgInfo.isOpenVoice}]"
                                         src="@/assets/images/project/v3/audio_icon.png"
                                         alt="">
                                </div>
                                <div class="time">
                                    {{ item.jgInfo.voice_time }}s
                                </div>
                                <div class="red-dit"></div>
                                <audio :ref="`jgInfo_${index}`" :src="item.jgInfo.voice"
                                       @ended="onAudioEnd(index,'jgInfo')"></audio>
                            </div>
                            <div v-if="item.jgInfo.pic && item.jgInfo.pic.length > 0" class="img-box">
                                <template v-for="(pic,pic_i) in item.jgInfo.pic">
                                    <div :class="['img-item',{'video_mask':pic.type != 'image'}]">
                                        <img alt="" @click="toPreview(item.jgInfo.pic,pic_i)"
                                             :src="pic.type == 'image' ? pic.pic : pic.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                    </div>
                                </template>
                            </div>
                            <div v-if="item.isShowUnfold" class="split"></div>
                        </div>
                    </template>
                    <!-- 追评 -->
                    <div v-if="item.zpInfo" class="discuss-box">
                        <div class="title">
                            <p> {{ item.zpInfo.date }}后追评 </p>
                        </div>
                        <div class="content">
                            {{ item.zpInfo.content }}
                        </div>
                        <div v-if="item.zpInfo.pic && item.zpInfo.pic.length > 0" class="img-box">
                            <template v-for="(pic,pic_i) in item.zpInfo.pic">
                                <div :class="['img-item',{'video_mask':pic.type != 'image'}]">
                                    <img alt="" @click="toPreview(item.zpInfo.pic,pic_i)"
                                         :src="pic.type == 'image' ? pic.pic : pic.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                </div>
                            </template>
                        </div>
                        <div v-if="item.isShowUnfold" class="split"></div>
                    </div>
                    <div v-if="item.isShowUnfold" class="unfold" @click="toDiscussUnfold(index)">
                        <p> {{ item.isUnfoldDiscuss ? '收起评价' : '展开评论' }}</p>
                        <div :class="['arrow-unfold',{'arrow':item.isUnfoldDiscuss}]"></div>
                    </div>
                </div>
            </template>
        </van-list>

        <media-preview :show="isShowPreview" :nIndex="nPreviewIndex" :arrUrl="arrPreview"
                       @close="closePreview"></media-preview>
        <!-- 评论分享 -->
        <posterPanel :show="isShowPosterPanel" :disId="disId" :projectId="projectId"
                     @close="isShowPosterPanel = false"></posterPanel>
    </div>
</template>

<script>
import {Rate} from 'vant';
import posterPanel from '../components/poster/index.vue';
import mediaPreview from '../components/preview/index.vue';
import {getCaseDiscussList, checkZxy, readNum} from "@/js/project/v3/index.js";

export default {
    name: "projectDiscuss",
    components: {
        vantRate: Rate,
        posterPanel,
        mediaPreview
    },
    data() {
        return {
            disId: '',
            projectId: '',
            isUnfold: false,
            nScreenIndex: 0,
            objNum: {
                total_num: 0,
                zhui_num: 0,
                pic_num: 0,
            },
            sortType: 'id',// id-默认，time-时间
            screenTag: [],
            nTagIndex: -1,
            arrDiscuss: [],
            isShowPosterPanel: false,
            isShowPreview: false,
            nPreviewIndex: 0,
            arrPreview: [],
            prevAudio: {
                index: '',
                key: '',
                el: null,
            },
            isZxy: false,
            tCensus: null,
            nPage: 0,
            isloading: false, //是否上拉加载状态
            isfinished: false,//是否加载完成
        }
    },
    created() {
        console.log(this.$route.query, 'this.$route.query')
        if (this.$route.query.mode == 2 && !this.tCensus) {
            this.addReadNum(this.$route.query.id, 'more_discuss', 'dis_more').then(result => {
                this.tCensus = setInterval(() => {
                    console.log('统计数据---更多评价')
                    // this.$toast('统计')
                    this.addReadNum(this.$route.query.id, 'more_discuss', 'dis_more', result)
                }, 5000)
            })
        }
        this.checkZxyFun();
        this.nPage = 0;
        this.getCaseDiscussListFun()
    },
    beforeRouteLeave(to, from, next) {
        if (this.tCensus) {
            clearInterval(this.tCensus)
            this.tCensus = ''
        }
        next()
    },
    methods: {
        randomNum() {
            return Math.round(Math.random() * 10) > 5
        },
        checkZxyFun() {
            return new Promise((resolve, reject) => {
                checkZxy().then((res) => {
                    this.isZxy = res.data.data.result;
                    resolve()
                })
            })
        },
        // 统计阅读量
        addReadNum(uuid, type, notice_type, log_id) {
            console.log('-56456456-')
            return new Promise(resolve => {
                let options = {
                    project_uuid: uuid,
                    type: type,
                    notice_type,
                    share_user_id: this.$route.query.share_id
                }
                if (log_id) {
                    options.log_id = log_id
                }
                readNum(options, false).then(res => {
                    resolve(res.data.data.result)
                })
            })
        },
        randomHead() {
            // return `https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/head-default${Math.floor(Math.random() * 4) + 1}.png`;
            return `https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/head-default.png`;
        },
        onListLoad() {
            this.nPage += 1;
            this.getCaseDiscussListFun()
        },
        getCaseDiscussListFun() {
            this.$store.commit("loadSwitch", true);
            let type = 'all';
            switch (this.nScreenIndex) {
                case 0:
                    type = 'all';
                    break;
                case 1:
                    type = 'pic';
                    break;
                case 2:
                    type = 'zhui ';
                    break;
            }
            getCaseDiscussList({
                page: this.nPage,
                limit: 10,
                project_uuid: this.$route.query.id,
                type: type,
                sort: this.sortType,
                sort_type: 'desc',
            }).then((res) => {
                let data = res.data.data.result;
                this.objNum = {
                    total_num: data.total_num,
                    zhui_num: data.zhui_num,
                    pic_num: data.pic_num,
                };

                this.screenTag = data.tags;
                if (data.lists && data.lists.length > 0) {
                    let list = data.lists.map((it) => {
                        let obj = {
                            isShow: false,
                            id: '',
                            project_uuid: '',
                            userInfo: '',
                            sgInfo: '',
                            jgInfo: '',
                            zpInfo: '',
                            isShowUnfold: false,
                            isUnfoldDiscuss: true
                        }
                        if (it && it.length > 0) {
                            obj.isShow = true;
                            obj.id = it[0].id;
                            obj.project_uuid = it[0].project_uuid;
                            obj.userInfo = {
                                // img: it[0].headimgurl,
                                img: it[0].headimgurl ? it[0].headimgurl : this.randomHead(),
                                // imgtype: this.randomNum(),
                                name: it[0].nickname,
                                time: it[0].created_at ? it[0].created_at.split(' ')[0].replaceAll('-', '.') : '',
                                isOrigin: it[0].project_uuid == this.$route.query.id
                            }
                            if (obj.userInfo.isOrigin) {
                                obj.project_id = this.$route.query.case_id || it[0].project_id;
                            } else {
                                obj.project_id = it[0].project_id;
                            }
                            obj.city = it[0].city || '--';
                            obj.project_name = it[0].project_name || '--';
                            it.forEach((dis) => {
                                if (dis.is_completed == 3) {
                                    obj.sgInfo = {
                                        score: dis.score,
                                        score_num: Number(dis.score),
                                        content: dis.content,
                                        pic: dis.pic,
                                        voice_time: dis.voice_time,
                                        voice: dis.voice,
                                        tags_name: dis.tags_name,
                                        time: dis.created_at ? dis.created_at.split(' ')[0].replaceAll('-', '.') : '',
                                        isOpenVoice: false //是否开始播放音频
                                    };
                                } else {
                                    obj.jgInfo = {
                                        score: dis.score,
                                        score_num: Number(dis.score),
                                        content: dis.content,
                                        pic: dis.pic,
                                        voice_time: dis.voice_time,
                                        voice: dis.voice,
                                        tags_name: dis.tags_name,
                                        time: dis.created_at ? dis.created_at.split(' ')[0].replaceAll('-', '.') : '',
                                        isOpenVoice: false //是否开始播放音频
                                    }
                                    if (dis.content2 && dis.zhui_time) {
                                        obj.zpInfo = {
                                            content: dis.content2,
                                            pic: dis.pic_zhui,
                                            zhui_time: dis.zhui_time,
                                            date: this.computTime(dis.zhui_time),
                                            time: dis.zhui_time ? dis.zhui_time.split(' ')[0].replaceAll('-', '.') : '',
                                        }
                                    }
                                }
                            })
                            /*
                            * obj.sgInfo false
                            * obj.sgInfo obj.jgInfo true
                            * obj.sgInfo obj.jgInfo obj.zpInfo true
                            * obj.jgInfo false
                            * obj.jgInfo obj.zpInfo true
                            * */
                            if ((obj.sgInfo && !obj.jgInfo) || (obj.jgInfo && !obj.sgInfo && !obj.zpInfo)) {
                                obj.isShowUnfold = false;
                                obj.isUnfoldDiscuss = true;
                            } else {
                                obj.isShowUnfold = true;
                            }
                        }
                        return obj
                    });

                    if (this.nPage == 0) {
                        this.arrDiscuss = list;
                    } else {
                        this.arrDiscuss.push(...list);
                    }

                    if (this.nTagIndex >= 0) {
                        this.toTag(this.nTagIndex)
                    }
                }
                this.isloading = false;
                if (this.arrDiscuss.length >= data.total_num) {
                    this.isfinished = true;
                } else {
                    this.isfinished = false;
                }
                this.$nextTick(() => {
                    this.handleScroll();
                    this.$store.commit("loadSwitch", false);
                })
            })
        },
        handleScroll() {
            let arrItem = this.$refs[`discuss_${this.$route.query.scrollId}`]
            if (arrItem && arrItem.length > 0) {
                let elItem = arrItem[0];
                let elDiscuss = this.$refs['discuss']
                let timer = setInterval(() => {
                    if (elDiscuss.scrollTop < elItem.offsetTop) {
                        elDiscuss.scrollTop += 30;
                    } else {
                        elDiscuss.scrollTop = elItem.offsetTop;
                        clearInterval(timer);
                        timer = null;
                    }
                }, 10)
            }
        },
        //获取时间差
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replaceAll(/-/g, '/');
            let zhuiTime = new Date(endTime);
            zhuiTime = zhuiTime.getTime();
            let diffTime = (nowTime - zhuiTime) / 1000
            let timeData = ''

            if (diffTime < 0) {
                timeData = '1天'
            } else if (0 < diffTime && diffTime < 86400) {
                timeData = '1天'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '个月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }

            return timeData
        },
        toScreenUnfold() {
            this.isUnfold = !this.isUnfold;
        },
        toScreen(i) {
            this.nScreenIndex = i;
            this.nPage = 0;
            this.getCaseDiscussListFun();
        },
        toSort() {
            if (this.sortType == 'id') {
                this.sortType = 'time';
            } else {
                this.sortType = 'id';
            }
            this.nPage = 0;
            this.getCaseDiscussListFun()
        },
        toTag(i) {
            this.nTagIndex = i;
            let tag = this.screenTag[i].title;
            if (this.arrDiscuss.length > 0) {
                this.arrDiscuss.forEach((it, index) => {
                    let arrTag = [];
                    for (let itKey in it) {
                        if (it[itKey].tags_name) {
                            arrTag.push(...it[itKey].tags_name)
                        }
                    }

                    let isShow = -1;
                    console.log(arrTag)

                    isShow = arrTag.findIndex((tag_it) => {
                        return tag_it == tag
                    })

                    it.isShow = isShow >= 0;
                })
            }
        },
        touchCase(id){
            if (id) {
                this.$router.push({
                    path: `/project/v3/case/details?id=${id}&mode=1&ut_source=ai_heating&isDis=1`
                })
            } else {
                this.$toast('项目信息错误')
            }
        },
        toDiscussUnfold(i) {
            this.arrDiscuss[i].isUnfoldDiscuss = !this.arrDiscuss[i].isUnfoldDiscuss;
        },
        toDiscussShare(item) {
            this.disId = String(item.id || '');
            this.projectId = item.project_uuid || '';
            this.isShowPosterPanel = true;
        },
        toPreview(arr, i) {
            this.arrPreview = arr;
            this.nPreviewIndex = i;
            this.isShowPreview = true;
            console.log(this.arrPreview)
        },
        closePreview() {
            this.isShowPreview = false;
        },
        playAudio(index, key) {
            let info = this.arrDiscuss[index][key];
            let el = this.$refs[`${key}_${index}`][0];

            if (this.prevAudio.key && this.prevAudio.key != key) {
                this.prevAudio.el.pause();
                this.prevAudio.el.load();
                this.arrDiscuss[this.prevAudio.index][this.prevAudio.key].isOpenVoice = false;
            }

            this.prevAudio.el = el;
            this.prevAudio.index = index;
            this.prevAudio.key = key;

            if (info.isOpenVoice) {
                info.isOpenVoice = false;
                el.pause();
                el.load();
            } else {
                info.isOpenVoice = true;
                el.play()
            }
        },
        onAudioEnd(index, key) {
            let info = this.arrDiscuss[index][key];
            info.isOpenVoice = false;
        },
        // 用户姓名*处理
        handleUserName(name) {
            const length = String(name).length
            switch (length) {
                case 1:
                    return name;
                    break;
                case 2:
                    return name.substring(0, 1) + '*';
                    break;
                case 3:
                    return name.substring(0, 1) + '*' + name.substr(-1);
                    break;
                default:
                    return name.substring(0, 1) + '**' + name.substr(-1)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
